

import React from "react";

export const CircularArrow = ({
  isOpen = false,
  disabled = false,
}: {
  isOpen?: boolean;
  disabled?: boolean;
}) => (
<svg
  style={{ transform: isOpen ? "rotate(0deg)" : "rotate(180deg)", transition: "transform 0.2s ease" }}
  width="32"
  height="32"
  viewBox="0 0 32 32"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <rect
    x="0.6"
    y="0.6"
    width="30.8"
    height="30.8"
    rx="15.4"
    stroke={disabled ? "#E9E8EC" : "#EDF1F6"}
    strokeWidth="1.2"
  />
  <path
    d="M22 19L16 13L10 19"
    stroke={disabled ? "#9897A9" : "#0D0C1C"}
    strokeWidth="1.2"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
</svg>
);
